import EmailOrPhoneAssociated from './EmailOrPhoneAssociated'
export default EmailOrPhoneAssociated
